type BemToCamel<T extends string> = T extends `${infer P}-${infer Rest}`
  ? `${P}${Capitalize<BemToCamel<Rest>>}`
  : T;

export function convertBemToCamel<T extends string>(
  className: T
): BemToCamel<T> {
  return className.replace(/-+(\w)/g, (_, letter) =>
    letter.toUpperCase()
  ) as BemToCamel<T>;
}
